import type { Notification } from '@/stores/notificationStore';

export interface NotificationDisplayContent {
  title?: string;
  message: string;
}

function getSingleValidationErrorMessage(notification: Pick<Notification, 'validationErrors'>): string | undefined {
  return notification.validationErrors?.length === 1 ? notification.validationErrors[0]?.message : undefined;
}

export function getNotificationDisplayContent(
  notification: Pick<Notification, 'type' | 'title' | 'message' | 'validationErrors'>
): NotificationDisplayContent {
  if (notification.type === 'error' || notification.type === 'warning') {
    const message =
      getSingleValidationErrorMessage(notification) ??
      (notification.message.trim() || notification.title.trim());
    return notification.type === 'warning'
      ? { title: notification.title, message }
      : { message };
  }

  return {
    title: notification.title,
    message: notification.message.trim(),
  };
}
